<template>
    <div name="contract" class="contract">
        <strong>위수탁 계약서</strong><br/>
        <br/>
        **(이하 “위탁자”라 한다)과 솔닥 주식회사(이하 “수탁자”라 한다)는 “위탁자”의 개인정보 처리업무를 “수탁자”에게 위탁함에 있어 다음과 같은 내용으로 본 업무위탁계약을 체결한다. <br/>
        <br/>
        제1조 (목적) 이 계약은 “위탁자”가 개인정보처리업무를 “수탁자”에게 위탁하고, “수탁자”는 이를 승낙하여 “수탁자”의 책임아래 성실하게 업무를 완성하도록 하는데 필요한 사항을 정함을 목적으로 한다. <br/>
        <br/>
        제2조 (용어의 정의) 본 계약에서 별도로 정의되지 아니한 용어는 「개인정보 보호법」, 같은 법 시행령 및 고시, 「개인정보의 안전성 확보조치 기준」(개인정보보호위원회 고시 제2021-2호) 및 「표준 개인정보 보호지침」(개인정보보호위원회 고시 제2020-1호)에서 정의된 바에 따른다. <br/>
        <br/>
        제3조 (위탁업무의 목적 및 범위) “수탁자”는 계약이 정하는 바에 따라 다음과 같은 업무를 수행한다.<br/>
        1. “수탁자”는 “위탁자”의 의료행위 및 요양급여 수령 등에 필요한 업무 처리를 위하여 “위탁자”의 환자로부터 주민등록번호, 연락처, 건강문진 정보, 결제수단, 의약품 배송 관련 정보를 수집∙저장한 후 “위탁자”에 제공하고, “위탁자”가 활용할 수 있게 하며, “위탁자”의 의료행위를 위하여 “위탁자”로부터 환자의 진료정보, 처방정보를 제공받아 환자의 진료 및 처방기록 관리, 처방 물품 배송을 지원한다.<br/>
        <br/>
        제4조 (위탁업무 기간) 이 계약서에 의한 개인정보 처리업무의 기간은 다음과 같다.<br/>
        계약 기간 : 본 계약 체결일로부터 당사자 일방의 해지일까지 <br/>
        <br/>
        제5조 (재위탁 제한) ① “수탁자”는 “위탁자”의 사전 승낙을 얻은 경우를 제외하고 “위탁자”와의 계약상의 권리와 의무의 전부 또는 일부를 제3자에게 양도하거나 재위탁할 수 없다.<br/>
        ② “수탁자”가 다른 제3의 회사와 위수탁계약을 체결할 경우에는 “수탁자”는 해당 사실을 계약 체결 7일 이전에 “위탁자”에게 통보하고 협의하여야 한다.  <br/>
        <br/>
        제6조 (개인정보의 안전성 확보 조치) “수탁자”는 「개인정보 보호법」 및 「개인정보의 안전성 확보조치 기준」(개인정보보호위원회 고시 제2021-2호)에 따라 개인정보의 안전성 확보에 필요한 관리적·기술적 조치를 취하여야 한다.<br/>
        <br/>
        제7조 (개인정보의 처리 제한) ① “수탁자”는 계약기간은 물론 계약 종료 후에도 위탁업무 수행 목적 범위를 넘어 개인정보를 이용하거나 이를 제3자에게 제공 또는 누설하여서는 안 된다.<br/>
        ② “수탁자”는 계약이 해지되거나 또는 계약기간이 만료된 경우 위탁업무와 관련하여 보유하고 있는 개인정보를 「개인정보 보호법」 제21조, 「개인정보 보호법 시행령」 제16조 및 「개인정보의 안전성 확보조치 기준」(개인정보보호위원회 고시 제2021-2호)에 따라 즉시 파기하거나 “위탁자”에게 반납하여야 한다. 단, “수탁자”가 개인정보주체로부터 별도 수집, 보관, 이용의 동의를 득한 개인정보는 그러하지 아니하다. <br/>
        ③ 제2항에 따라 “수탁자”가 개인정보를 파기한 경우 지체없이 “위탁자”에게 그 결과를 통보하여야 한다.<br/>
        <br/>
        제8조 (수탁자에 대한 관리·감독 등) ① “위탁자”는 “수탁자”에 대하여 다음 각 호의 사항을 감독할 수 있으며, “수탁자”는 특별한 사유가 없는 한 이에 응하여야 한다.<br/>
        1. 개인정보의 처리 현황<br/>
        2. 개인정보의 접근 또는 접속현황<br/>
        3. 개인정보 접근 또는 접속 대상자<br/>
        4. 목적외 이용·제공 및 재위탁 금지 준수여부<br/>
        5. 암호화 등 안전성 확보조치 이행여부<br/>
        6. 그 밖에 개인정보의 보호를 위하여 필요한 사항<br/>
        ② “위탁자”는 “수탁자”에 대하여 제1항 각 호의 사항에 대한 실태를 점검하여 시정을 요구할 수 있으며, “수탁자”는 특별한 사유가 없는 한 이행하여야 한다.<br/>
        ③ “위탁자”는 정보주체의 개인정보가 분실·도난·유출·변조 또는 훼손되지 아니하도록 1년에 1회 “수탁자”를 교육할 수 있으며, “수탁자”는 이에 응하여야 한다.<br/>
        ④ 제1항에 따른 교육의 시기와 방법 등에 대해서는 “위탁자”는 “수탁자”와 협의하여 시행한다.<br/>
        <br/>
        제9조 (정보주체 권리보장) ① “수탁자”는 정보주체의 개인정보 열람, 정정·삭제, 처리 정지 요청 등에 대응하기 위한 연락처 등 민원 창구를 마련해야 한다.<br/>
        <br/>
        제10조 (개인정보의 파기) ① “수탁자”는 제4조의 위탁업무기간이 종료되면 특별한 사유가 없는 한 지체 없이 개인정보를 파기하거나 반환하고 이를 “위탁자”에게 확인받아야 한다. 단, 수탁자가 개인정보주체로부터 별도 수집, 보관, 이용의 동의를 득한 개인정보는 그러하지 아니하다. <br/>
        <br/>
        제11조 (손해배상) “수탁자”의 귀책사유로 “위탁자” 또는 개인정보주체 기타 제3자에게 손해가 발생한 경우 “수탁자”는 그 손해를 배상하여야 한다.<br/>
        <br/>
        [수탁자]<br/>
        솔닥 주식회사<br/>
        서울특별시 강남구 학동로33길 17, 3층<br/>
        공동대표이사 김민승<br/>
        공동대표이사 이호익<br/>
    </div>
</template>

<script>
export default {
    name: 'contract'
}
</script>

<style scoped>
    .contract{
        padding: 20px;
        padding-top: 40px;
        background: #FFFFFF;
    }
</style>



// WEBPACK FOOTER //
// src/pages/partners/contents/contract/20230314.vue